export default __webpack_public_path__ + "static/media/(48).a07b798b.jpg";